import create from 'zustand';
import { EmittenInfoResponse } from '../types/api/emittenInfo';
import { getEmittenInfo } from '../api/emitten';

type DataTypes = EmittenInfoResponse | Record<string, never>;

interface State {
  data: DataTypes;
  isLoading: boolean;
}

interface Action {
  loadEmittenInfo: (symbol: string) => Promise<EmittenInfoResponse>;
  resetEmittenInfo: () => void;
  updateEmittenInfo: (
    newData: Partial<EmittenInfoResponse> | Record<string, never>,
  ) => void;
}

const initialState: State = {
  data: {},
  isLoading: false,
};

const useEmittenInfoStore = create<State & Action>((set) => ({
  ...initialState,
  loadEmittenInfo: async (symbol) => {
    try {
      set({ isLoading: true });

      const axiosResponse = await getEmittenInfo(symbol);
      const { data } = axiosResponse.data;

      set({ data, isLoading: false });

      return data;
    } catch (error) {
      set({ isLoading: false });
      return Promise.reject(error);
    }
  },
  resetEmittenInfo: () => {
    set(initialState);
  },
  updateEmittenInfo: (newData) => {
    set((state) => ({
        data: { ...state.data, ...newData } as DataTypes,
      }));
  },
}));

export default useEmittenInfoStore;
